import * as React from "react";
import Container from "../Container/Container";
import "./BookInProgress.scss";

// markup
export default function BookArchive(props) {
  return (
    <section
      id="book-in-progress"
      className="book-cta book-in-progress u-pad-top-xl u-pad-btm-xl"
    >
      <h2 className="book-cta__heading book-in-progress__heading">
        This book is a{" "}
        <span className="book-in-progress__heading-highlight">Work in Progress</span>
      </h2>
      <Container name="book-in-progress">
        <p>
          <strong>I’m currently working on this book.</strong> If you'd like to read along as I post new chapters, check out the book on Wattpad!
          { 
            // This is something I’m currently working on. If you want updates on my progress&mdash;including first drafts of chapters&mdash;check out my{" "} Patreon {props.wattpad && ('and Wattpad ')}account, where I give my patrons first-looks at all my work.
          } 
        </p>
        <div className="book-in-progress__buttons">
          { 
            // <a
            // href="https://patreon.com/yvetterussell"
            // target="_new"
            // className="book-cta__button book-in-progress__button"
            // >
            // Read on Patreon
            // </a>
          }
          <a
            href={props.wattpad}
            target="_new"
            className="book-cta__button book-in-progress__button"
          >
            Read on Wattpad
          </a>
        </div>
      </Container>
    </section>
  );
}
